import api from 'api';

interface RecoverTasksResult {
  recovered_count: number;
  task_ids: string[];
}

export default function bulkResetFailedTasks(
  projectId: string,
  workflowId: string,
): Promise<RecoverTasksResult> {
  return api
    .post(`projects/${projectId}/workflows/${workflowId}/tasks/bulk-reset-failed`)
    .json();
}
